"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const InfoTableKeys = Object.freeze({
    DATE_TIME: "dateTime",
    IR_SENSOR_SIZE: "irSensorSize",
    CAPTURED_BACKGROUND_TEMP: "capturedBackgroundTempC",
    CAPTURED_EMISSIVITY: "capturedEmissivity",
    CAPTURED_TRANSMISSION: "capturedTransmissionFactor",
    CALIBRATION_RANGE: "calibrationRange",
    CAMERA_SERIAL_NUMBER: "cameraSerialNumber",
    CAMERA_MODEL: "cameraModel",
    COMPANY_NAME: "companyName",
    SEVERITY: "severity"
});
const _default = InfoTableKeys;
